
/*
Додати в запит GET ключ filter
*/

import { defineStore } from 'pinia'
import { toRaw } from 'vue'
import {APIRequest,arrayToMap,alertMessage} from '@/utils/common.js'
import axios from 'axios'
const base = import.meta.env.VITE_API_URL

function hasOrdnungDuplicates(list) {
  if (!Array.isArray(list)) return false
  const byKey = new Map()
  for (const g of list) {
    const key = `${g.config_id ?? 0}:${g.obj_id ?? 'null'}`
    if (!byKey.has(key)) byKey.set(key, new Map())
    if (typeof g.ordnung !== 'number') continue
    const ord = g.ordnung
    byKey.get(key).set(ord, (byKey.get(key).get(ord) || 0) + 1)
  }
  for (const ordMap of byKey.values()) {
    for (const count of ordMap.values()) {
      if (count > 1) return true
    }
  }
  return false
}

function hasOrdnungValues(list) {
  return Array.isArray(list) && list.some(x => typeof x?.ordnung === 'number')
}

function sortByOrdnungIfNeeded(list) {
  if (!hasOrdnungValues(list)) return
  list.sort((a, b) => {
    const aHas = typeof a?.ordnung === 'number'
    const bHas = typeof b?.ordnung === 'number'
    if (aHas && bHas) return a.ordnung - b.ordnung
    if (aHas) return -1
    if (bHas) return 1
    return 0
  })
}

function normalizeMovePayload(moveInput, defaultKey) {
  if (moveInput && typeof moveInput === 'object' && !Array.isArray(moveInput)) {
    return { ...moveInput }
  }
  if (moveInput === undefined) return {}
  return { [defaultKey]: moveInput }
}

//аргумент "par" - це не обов'язковий  рядок, який додається в кінець endpoint url
function apiStore(dataName,endpoint,par='') {
  let pendingLoad = null
  return defineStore(dataName, {
    state: () => ({
      list: [],
      idMap: new Map(),
      byFilter:null,          //фільтр, який був застосований серевером у відповіді на GET
      loadRequestId:0
    }),
    actions: {
      _snapshotList() {
        return Array.isArray(this.list) ? structuredClone(toRaw(this.list)) : []
      },
      _restoreList(snapshot) {
        this.list = Array.isArray(snapshot) ? snapshot : []
        arrayToMap(this.list, this.idMap, "id")
        sortByOrdnungIfNeeded(this.list)
      },
      _patchItem(resp) {
        if (!resp) return null
        if (Array.isArray(resp)) {
          resp.forEach((r) => {
            const idx = this.list.findIndex(item => item.id === r.id)
            if (idx >= 0) this.list[idx] = r
            this.idMap.set(r.id, r)
          })
//this.list.splice(0, this.list.length, ...resp)
          arrayToMap(this.list, this.idMap, "id")
        } else {
          const idx = this.list.findIndex(item => item.id === resp.id)
          if (idx >= 0) this.list[idx] = resp
          this.idMap.set(resp.id, resp)
//this.list.splice(0, this.list.length, ...Array.from(this.idMap.values()))
        }
        return resp
      },
      async load(firstLoadMode,filter) {
        if (pendingLoad && pendingLoad.filter === filter) return pendingLoad.promise
        if(firstLoadMode && this.byFilter===filter) return
        const requestId = ++this.loadRequestId
        const promise = (async () => {
          let url = `${base}/${endpoint}${par}`
          if(filter) url+="?"+filter
          const loadedList = await APIRequest(axios.get(url))
          if (requestId !== this.loadRequestId) return null
          this.list = loadedList
          if (loadedList) {
            this.byFilter=filter
            arrayToMap(this.list, this.idMap, "id")
            sortByOrdnungIfNeeded(this.list)
            return this.list
          }
          alertMessage(`Помилка завантаження даних <br>. Сховище: ${dataName}`)
        })()
        pendingLoad = { filter, promise }
        try {
          return await promise
        } finally {
          if (pendingLoad?.promise === promise) pendingLoad = null
        }
      },
      clearForFilter(filter) {
        this.loadRequestId += 1
        this.list = []
        this.idMap.clear()
        this.byFilter = filter
      },
      async update(id,payload,par='') {
        const resp = await APIRequest(axios.put(`${base}/${endpoint}/${id}${par}`, payload))
        if (resp) {
          return this._patchItem(resp)
        }
        alertMessage(`Помилка збереження даних. <br> Сховище: ${dataName}`)
      },
      async create(payload) {
        const resp = await APIRequest(axios.post(`${base}/${endpoint}`, payload))
        if (resp) {
          this.idMap.set(resp.id, resp)
          this.list.push(resp)
          sortByOrdnungIfNeeded(this.list)
          return resp
        }
        alertMessage(`Помилка збереження даних. <br> Сховище: ${dataName}`)
      },
      async deleteSoft(id) {
        const resp = await APIRequest(axios.delete(`${base}/${endpoint}/${id}`))
        if (resp) {
          this.idMap.set(resp.id, resp)
          const idx = this.list.findIndex(item => item.id === resp.id)
          if(idx>=0) this.list[idx]=resp
          return resp
        }
        alertMessage(`Помилка видалення даних. <br> Сховище: ${dataName}`)
      },
      async deleteHard(id) {
        const resp = await APIRequest(axios.delete(`${base}/${endpoint}/${id}?force=true`))
        if (resp) {
          this.idMap.delete(id)
          const idx = this.list.findIndex(item => item.id === id)
          if (idx >= 0) this.list.splice(idx, 1)
          this.idMap.delete(id)
          return resp
        }
        alertMessage(`Помилка видалення даних. <br> Сховище: ${dataName}`)
      },
      async restore(id,grp_id) {
        const resp = await APIRequest(axios.put(`${base}/${endpoint}/${id}/restore`))
        if (resp) {
          this.idMap.set(resp.id, resp)
          const idx = this.list.findIndex(item => item.id === resp.id)
          if(idx>=0) this.list[idx]=resp
          return resp
        }
        alertMessage(`Помилка відновлення даних. <br> Сховище: ${dataName}`)
      },
      async moveNode(id, moveInput) {
        const payload = normalizeMovePayload(moveInput, 'parent_id')
        const resp = await APIRequest(axios.put(`${base}/${endpoint}/${id}/move`, payload))
        if (resp) {
          if (typeof payload.ordnung === 'number') {
            await this.load(false,this.byFilter)
          } else {
            this._patchItem(resp)
            sortByOrdnungIfNeeded(this.list)
          }
          return resp
        }
        await this.load(false,this.byFilter)
        return null
      },
      async moveElement(id, moveInput) {
        const payload = normalizeMovePayload(moveInput, 'grp_id')
        const resp = await APIRequest(axios.put(`${base}/${endpoint}/${id}/move`, payload))
        await this.load(false,this.byFilter)
        return resp
      }
    }
  })
}

export const useOTypeStore        = apiStore("Типи об`ектів",'d-setup-object-type')
export const useOTreeStore        = apiStore("Дерево типів об`ектів",'d-setup-tree')

export const useRightStore        = apiStore("Права доступу",'rights','/full')
export const useCashFormStore     = apiStore("Форми оплати",'cash-forms')
export const useRoleStore         = apiStore("Ролі клієнта",'roles')
export const useLunchStore        = apiStore("Прийоми їжі",'lunch')
export const useComplTypeStore    = apiStore("Типи комплексів",'f-complex')
export const useMarmiteStore      = apiStore("Місця видачі страв",'f-marmite')
export const useTerminalStore     = apiStore("Термінали роздачі",'f-terminal')

export const useResGroupStore     = apiStore("Групи ресурсів",'resources/groups')
export const useResourceStore     = apiStore("Ресурси системи",'resources')

export const usePerTreeStore      = apiStore("Групи персоналу",'pep-trees')
export const usePerStore          = apiStore("Персонал",'personal')

export const useClientTreeStore   = apiStore("Групи контрагентів",'cli-trees')
export const useClientStore       = apiStore("Контрагенти",'clients')
export const useCatStore          = apiStore("Категорії клієнтів",'age-cats')

export const useFClientStore      = apiStore("Клієнти",'f-clients')
export const useFClientGrpStore   = apiStore("Групи клієнтів",'f-client-groups')

export const useSchoolOrderStore  = apiStore("Замовлення",'school-orders','/list')
export const useSchoolOrderGlobalStore = apiStore("Усі замовлення",'school-orders','/global')

export const useSConfigStore      = apiStore("Системна конфігурація",'s-config')
export const useFlagStore         = apiStore("Перелік флагів",'common/dictinary/flags')

export const useArtTreeStore      = apiStore("Дерево артикулів",'articuls/tree')
export const useArticulStore      = apiStore("Артикули",'articuls')
export const useArtComplStore     = apiStore("Технологічна карта",'articuls/complect')
export const useArtAttrStore      = apiStore("Атрибути артикула",'articuls/attributes')
export const useArtCatStore       = apiStore("Категорії артикула",'articuls/category')

export const useUnitStore         = apiStore("Одиниці виміру",'units')
export const useFoodClaimStore    = apiStore("Харчові маркери",'food-claims')

export const useMTimeTreeStore    = apiStore("Дерево розкладів меню",'f-menu-time-tree')
export const useMenuTimeStore     = apiStore("Розклади меню",'f-menu-time')

//сховище страв меню певного config_id
export const useMenuGroupStore    = apiStore("Групи складових меню",'f-menu-group')
export const useMenuStore         = apiStore("Складові меню",'menu')
//сховище страв загального переліку (config_id=0)
export const useDishGroupStore    = apiStore("Групи переліку страв",'f-menu-group')
export const useDishStore         = apiStore("Перелік страв",'menu')


const allStores = [
  useOTypeStore,
  useOTreeStore,

  useRightStore,
  useCashFormStore,
  useRoleStore,
  useLunchStore,
  useComplTypeStore,
  useMarmiteStore,
  useTerminalStore,

  useResourceStore,
  usePerTreeStore,
  usePerStore,

  useArtTreeStore,
  useArticulStore,
  useArtComplStore,
  useArtAttrStore,

  useClientTreeStore,
  useClientStore,
  useCatStore,

  useFClientStore,
  useFClientGrpStore,

  useMarmiteStore,
  useSConfigStore,
  useFlagStore,

  useMTimeTreeStore,
  useMenuTimeStore,
  useMenuGroupStore,
  useMenuStore,

  useDishGroupStore,
  useDishStore,

  useUnitStore,
  useFoodClaimStore
]

export async function loadAll(storeInLoad) {
  for (const useStore of allStores) {
    const store = useStore()
    storeInLoad(store.$id)
    await store.load()
  }
}

//в режимі firstLoadMode завантажуються тільки порожні сховища в storePart
export async function loadPart(storePart, firstLoadMode) {
  let preloaderShown = false
  try{
    for (const key of Object.keys(storePart)) {
      if (!preloaderShown) {
          togglePreloader(true)
          preloaderShown = true
      }
      if(!firstLoadMode) await storePart[key].load(false,storePart[key].filter)
      else await storePart[key].load(true,storePart[key].filter)
    }
  }finally {

    if (preloaderShown){
      togglePreloader(false)
    }
  }
}

export async function firstLoad(storePart) {
  await loadPart(storePart, true)
}


function togglePreloader(show) {
  if (typeof document === 'undefined') return
  const preloaderEl = document.querySelector('.preloader')
  if (!preloaderEl) return
  preloaderEl.style.display = show ? 'block' : 'none'
}
